import { flexRender } from "@tanstack/react-table";
import React from "react";
import { MdOutlineArrowDropDown, MdOutlineArrowDropUp } from "react-icons/md";
import { useSelector } from "react-redux";
import { Td } from "../";
import { NumberFormatter } from "../../../../../CommonFunction/common";
const renderGroupedCell = (cell, row) => {
  // This renders the content for a grouped cell, including the expander
  return (
    <>
      <span
        onClick={row.getToggleExpandedHandler()}
        style={{ cursor: "pointer" }}
      >
        {row.getIsExpanded() ? (
          <MdOutlineArrowDropDown />
        ) : (
          <MdOutlineArrowDropUp />
        )}
      </span>
      {` ${cell.getValue()} (${row.subRows.length})`}
    </>
  );
};
const TableRow = ({
  row,
  isRowSelected,
  activeCell,
  setActiveCell,
  title,
  setActiveCellCoords,
  onDoubleClick,
  columnsView,
}) => {
  const { selectedRow } = useSelector((store) => store.FormFieldData);

  return (
    <tr
      key={row.original?._id}
      onDoubleClick={onDoubleClick}
      className={isRowSelected ? "selected-row" : ""}
      style={{
        background:
          ((selectedRow && selectedRow[0]?._id) ||
            (selectedRow && selectedRow[0]?.id)) ===
            (row.original?._id || row.original?.id)
            ? "#E0EDD9"
            : "",
      }}
    >
      {row.getVisibleCells().map((cell, index) => {
        // console.log(cell.column.columnDef.accessorKey?.toLowerCase())
        // -------   This part of code Abhishek has changed. ----------------
        let formattedValue;
        if (React.isValidElement(cell.getValue())) {
          formattedValue = cell.getValue();
        } else if (
          (typeof cell.getValue() === "number" &&
            cell.column.columnDef.accessorKey
              ?.toLowerCase()
              .includes("amount")) ||
          cell.column.columnDef.accessorKey
            ?.toLowerCase()
            .includes("opening_balance") ||
          cell.column.columnDef.accessorKey
            ?.toLowerCase()
            .includes("openingBalance") ||
          cell.column.columnDef.accessorKey
            ?.toLowerCase()
            .includes("closing_balance") ||
          cell.column.columnDef.accessorKey
            ?.toLowerCase()
            .includes("closing_in_cr") ||
          cell.column.columnDef.accessorKey
            ?.toLowerCase()
            .includes("closing_in_dr") ||
          cell.column.columnDef.accessorKey
            ?.toLowerCase()
            .includes("totalcredit") ||
          cell.column.columnDef.accessorKey
            ?.toLowerCase()
            .includes("totaldebit") ||
          cell.column.columnDef.accessorKey
            ?.toLowerCase()
            .includes("monthlyclosing") ||
          cell.column.columnDef.accessorKey
            ?.toLowerCase()
            .includes("closingbalance") ||
          cell.column.columnDef.accessorKey
            ?.toLowerCase()
            .includes("account_balance")
        ) {
          formattedValue = NumberFormatter(cell.getValue());
          // } else if (cell.getValue() === true) {
          //   formattedValue = "Yes";
          // } else if (cell.getValue() === false) {
          //   formattedValue = "No";
        } else {
          formattedValue = flexRender(
            cell.column.columnDef.cell,
            cell.getContext()
          );
        }

        // -----------------------------------------------------------------------------------------
        const activeCellStyle = {
          textAlign:
            cell?.column?.id === "Credit" ||
              cell?.column?.id === "Debit" ||
              cell?.column?.id === "Opening" ||
              cell?.column?.id === "ClosingBalance" ||
              cell?.column?.id === "Opening_Balance" ||
              cell?.column?.id === "openingBalance" ||
              cell?.column?.id === "Closing_In_Cr" ||
              cell?.column?.id === "Closing_In_Dr" ||
              typeof cell.getValue() == "number"
              ? "right"
              : "",
          background:
            activeCell === cell.id &&
              (row.original?._id || row.original?.id) ===
              (selectedRow[0]?._id || selectedRow[0]?.id)
              ? "#C6DEB9"
              : "",
          boxShadow:
            activeCell === cell.id &&
              (row.original?._id || row.original?.id) ===
              (selectedRow[0]?._id || selectedRow[0]?.id)
              ? "inset 0px 0px 0px 2px #acc1a1"
              : "",
        };
        // Check if the cell belongs to a grouped row

        return (
          cell.column.id === "select" && (
            <Td
              key={row.original?._id}
              title={title}
              e={row}
              onClick={() => {
                setActiveCell(cell.id);
                setActiveCellCoords({
                  rowIndex: row.index,
                  colKey: cell.column.columnDef.accessorKey,
                });
              }}
              style={activeCellStyle}
            >
              {cell.getIsGrouped() ? (
                <span style={{ fontWeight: "bold" }}>{renderGroupedCell(cell, row)} </span>
              ) : (
                formattedValue
              )}
            </Td>
          )
        );
      })}
      {row.getVisibleCells().map((cell, index) => {
        // -------   This part of code Abhishek has changed. ----------------
        let formattedValue;
        if (React.isValidElement(cell.getValue())) {
          formattedValue = cell.getValue();
        } else if (
          (typeof cell.getValue() === "number" &&
            (cell.column.columnDef.accessorKey
              ?.toLowerCase()
              .includes("amount") ||
              cell.column.columnDef.accessorKey
                ?.toLowerCase()
                .includes("opening_balance") ||
              cell.column.columnDef.accessorKey
                ?.toLowerCase()
                .includes("closing_balance") ||
              cell.column.columnDef.accessorKey
                ?.toLowerCase()
                .includes("closing_in_cr") ||
              cell.column.columnDef.accessorKey
                ?.toLowerCase()
                .includes("closing_in_dr") ||
              cell.column.columnDef.accessorKey
                ?.toLowerCase()
                .includes("account_balance") ||
              cell.column.columnDef.accessorKey
                ?.toLowerCase()
                .includes("credit") ||
              cell.column.columnDef.accessorKey
                ?.toLowerCase()
                .includes("debit") ||
              cell.column.columnDef.accessorKey
                ?.toLowerCase()
                .includes("closingbalance"))) ||
          cell.column.columnDef.accessorKey
            ?.toLowerCase()
            .includes("monthlyclosing")
        ) {
          formattedValue = NumberFormatter(cell.getValue());
          // } else if (cell.getValue() === true) {
          //   formattedValue = "Yes";
          // } else if (cell.getValue() === false) {
          //   formattedValue = "No";
        } else {
          formattedValue = flexRender(
            cell.column.columnDef.cell,
            cell.getContext()
          );
        }
        // -----------------------------------------------------------------------------------------
        const activeCellStyle = {
          // width: "10px",
          textAlign:
            cell?.column?.id === "Credit" ||
              cell?.column?.id === "Debit" ||
              cell?.column?.id === "Opening" ||
              cell?.column?.id === "ClosingBalance" ||
              cell?.column?.id === "Opening_Balance" ||
              cell?.column?.id === "Closing_In_Cr" ||
              cell?.column?.id === "Closing_In_Dr" ||
              typeof cell.getValue() == "number"
              ? "right"
              : "",
          background:
            activeCell === cell.id &&
              (row.original?._id || row.original?.id) ===
              (selectedRow[0]?._id || selectedRow[0]?.id)
              ? "#C6DEB9"
              : "",
          boxShadow:
            activeCell === cell.id &&
              (row.original?._id || row.original?.id) ===
              (selectedRow[0]?._id || selectedRow[0]?.id)
              ? "inset 0px 0px 0px 2px #acc1a1"
              : "",
        };
        // Check if the cell belongs to a grouped row
     
        return (
          cell.column.id !== "id" &&
          cell.column.id !== "_id" &&
          !(columnsView.includes(cell.column.id)) &&
          cell.column.id !== "select" && (
            <Td
              title={title}
              e={row}
              onClick={() => {
                setActiveCell(cell.id);
                setActiveCellCoords({
                  rowIndex: row.index,
                  colKey: cell.column.columnDef.accessorKey,
                });
              }}
              style={activeCellStyle}
            >
              {cell.getIsGrouped() ? (
                <span style={{ fontWeight: "bold" }}>{renderGroupedCell(cell, row)} </span>
              ) : (
                formattedValue
              )}
            </Td>
          )
        );
      })}
    </tr>
  );
};

export default TableRow;
